import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Badge, IconButton, TextButton, Typography } from 'seagull';
import { Trash } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import s from './ServicesCard.module.scss';
export const GetServiceRowTID = (parentTestId)=>getTestIds(parentTestId);
export const ServiceRow = (param)=>{
    let { service, onRemove, onUseTemplate, onUseFileVersion, isTemplateActionDisabled, isTemplateActionLoading, isDragActive, dragHandle, testId } = param;
    const { ServiceRowTestIds } = useMemo(()=>GetServiceRowTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys();
    const billingTriggerLabel = service.billingTriggerLabel(t);
    const suggestion = service.suggestionMessage(t);
    const showNewServiceBadge = service.showNewServiceBadge();
    const { priceAfterDiscount, priceBeforeDiscount, discountBadgeText } = service.priceDisplay(t);
    const isUseTemplate = (suggestion === null || suggestion === void 0 ? void 0 : suggestion.action) === 'useTemplate';
    const actionHandler = isUseTemplate ? onUseTemplate : onUseFileVersion;
    const actionDisabled = isUseTemplate && (isTemplateActionDisabled || isTemplateActionLoading);
    const actionTooltip = isUseTemplate && isTemplateActionDisabled ? {
        title: t.agreementImport.triageModal.services.templateUnavailableTooltip()
    } : undefined;
    const actionBiName = isUseTemplate ? 'agreement_triage_service_use_template' : 'agreement_triage_service_use_file_version';
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": ServiceRowTestIds.Root(),
        className: s.row,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: s.rowHeader,
                children: [
                    dragHandle != null && /*#__PURE__*/ _jsx("div", {
                        className: s.dragHandleSlot,
                        children: dragHandle
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h5",
                        testId: ServiceRowTestIds.DisplayName(),
                        className: s.displayName,
                        children: service.displayName()
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: s.trashWrapper,
                        children: /*#__PURE__*/ _jsx(IconButton, {
                            testId: ServiceRowTestIds.TrashButton(),
                            onClick: onRemove,
                            bi: {
                                name: 'agreement_triage_service_remove'
                            },
                            children: /*#__PURE__*/ _jsx(Trash, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: s.priceRow,
                children: [
                    service.isPriceMissing() ? /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        skin: "disabled",
                        testId: ServiceRowTestIds.PriceText(),
                        children: priceAfterDiscount
                    }) : /*#__PURE__*/ _jsx(Typography, {
                        variant: "h4",
                        testId: ServiceRowTestIds.PriceText(),
                        children: priceAfterDiscount
                    }),
                    priceBeforeDiscount != null && /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        skin: "secondary",
                        textDecoration: "line-through",
                        testId: ServiceRowTestIds.PriceBeforeDiscount(),
                        children: priceBeforeDiscount
                    }),
                    discountBadgeText != null && /*#__PURE__*/ _jsx(Badge, {
                        testId: ServiceRowTestIds.DiscountBadge(),
                        skin: "success",
                        rounded: true,
                        outlined: true,
                        children: discountBadgeText
                    }),
                    billingTriggerLabel != null && /*#__PURE__*/ _jsx(Badge, {
                        testId: ServiceRowTestIds.BillingTriggerBadge(),
                        rounded: true,
                        outlined: true,
                        children: billingTriggerLabel
                    }),
                    showNewServiceBadge && /*#__PURE__*/ _jsx(Badge, {
                        testId: ServiceRowTestIds.NewServiceBadge(),
                        skin: "primary",
                        rounded: true,
                        outlined: true,
                        children: t.agreementImport.triageModal.services.newServiceBadge()
                    })
                ]
            }),
            !isDragActive && suggestion != null && /*#__PURE__*/ _jsxs("div", {
                className: s.messageRow,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        "data-testid": ServiceRowTestIds.SuggestionMessage(),
                        className: s.suggestionMessage,
                        children: [
                            suggestion.prefix != null && /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph2",
                                children: "".concat(suggestion.prefix, " ")
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph2",
                                weight: "normal",
                                children: suggestion.emphasizedName
                            }),
                            suggestion.suffix != null && /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph2",
                                children: " ".concat(suggestion.suffix)
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(TextButton, {
                        testId: ServiceRowTestIds.ActionButton(),
                        onClick: actionHandler,
                        disabled: actionDisabled,
                        tooltip: actionTooltip,
                        underline: "none",
                        variant: "paragraph2",
                        weight: "normal",
                        bi: {
                            name: actionBiName
                        },
                        children: suggestion.actionLabel
                    })
                ]
            })
        ]
    });
};
